import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return ({
		filterBar: {
			marginBottom: theme.spacing(2),
		},
		detailLabel: {
			fontWeight: 600,
		},
	} satisfies Record<string, CSSObject>);
};
